const getCurrentWindowWidth = () => {
  if (typeof document === "undefined" || typeof window === "undefined") return 768;
  const width = Math.max(document?.documentElement.clientWidth, window?.innerWidth || 0);
  return width;
};
const isMobile = () => {
  try {
    const isMob = getCurrentWindowWidth() < 768;
    return isMob;
  } catch (err) {
    console.error("IsMobile Error", err);
    return false;
  }
};
const isMobileOrTablet = () => {
  try {
    const isMobOrTab = getCurrentWindowWidth() < 1024;
    return isMobOrTab;
  } catch (err) {
    console.error("IsMobileORTAb Error", err);
    return false;
  }
};

export { getCurrentWindowWidth, isMobile, isMobileOrTablet };
//# sourceMappingURL=src-utils-mobile-utils.js.map
